
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Doughnut as DoughtNutChart, mixins } from 'vue-chartjs'
import Chart from "chart.js";

const { reactiveProp } = mixins

@Component({
    extends: DoughtNutChart,
    mixins: [reactiveProp]
})
export default class Doughnut extends Vue {
    @Prop() 
    chartData: any;

    public renderChart!: (chartData: any, options: any) => void; //filled by chartjs
    mounted() {
        Chart.defaults.global.defaultFontFamily = "LinotypeUnivers";
        var model = this;
        var options = {
            responsive: false,
            tooltips: {
                callbacks: {
                    label: function(tooltipItem: any, data: any) {
                        return data.labels[tooltipItem.index];
                    }
                }
            }
        }
        this.renderChart(this.chartData, options);
    }
}
